<div class="cart-wizard-section-heading" fxLayout="row wrap" fxLayoutAlign="space-between center">
    <div class="cart-wizard-section-heading__copy">
        <strong class="cart-wizard-section-heading__title">{{ 'ADD_NEW_CAMPAIGN' | translate }}</strong>
        <p class="cart-wizard-section-heading__subtitle">{{ 'LOCATION_DETAILS_TIP' | translate }}</p>
    </div>
    <div class="cart-wizard-section-heading__actions">
        <button type="button" class="gray-button" (click)="changeSelection(false)">{{ 'CHANGE_SELECTION' | translate }}</button>
    </div>
</div>

<div class="form-container new-campaign-form-shell">
    <form class="new-campaign-form" [formGroup]="campForm" (ngSubmit)="onSubmit()">
        <section class="cart-wizard-section-card">
            <div class="cart-wizard-section-card__header">
                <h2 class="cart-wizard-section-card__title">{{ 'CAMPAIGN_BASICS' | translate }}</h2>
                <p class="cart-wizard-section-card__copy">{{ 'CHOOSE_THE_CLIENT_RECORD_AND_DEFINE_HOW_THIS_CAMPAIGN_SHOULD_BE_LABELED' | translate }}</p>
            </div>

            <div class="form-row">
            <div class="dropdown">
                <label>{{ 'CLIENT_RECORD' | translate }}*</label>
                <ng-select 
                    [clearable]="false" 
                    (change)="clientFilterChange($event);changeCompanyFill($event);" 
                    [ngClass]="{'is-invalid': attemptClick && campForm.get('clientId')?.invalid}" 
                    bindLabel="fullName" 
                    bindValue="id" 
                    [items]="tempClients" 
                    formControlName="clientId">
                </ng-select>
                <div *ngIf="attemptClick && campForm.get('clientId')?.invalid" class="invalid-feedback">
                    {{ 'CLIENT_RECORD_REQUIRED' | translate }}
                </div>
            </div>

            <div>
                <label>{{ 'BRAND_NAME' | translate }}*</label>
                <input 
                    [ngClass]="{'is-invalid': attemptClick && campForm.get('brandName')?.invalid}" 
                    (change)="onNameChange($event)" 
                    type="text" 
                    formControlName="brandName" 
                    class="form-control" 
                />
                <div *ngIf="attemptClick && campForm.get('brandName')?.invalid" class="invalid-feedback">
                    {{ 'BRAND_NAME_REQUIRED' | translate }}
                </div>
            </div>

            <div>
                <label>{{ 'STUDIO_LOCATION_NAME' | translate }}*</label>
                <input 
                    [ngClass]="{'is-invalid': attemptClick && campForm.get('studioLocationName')?.invalid}" 
                    (change)="onNameChange($event)" 
                    type="text" 
                    formControlName="studioLocationName" 
                    class="form-control" 
                />
                <div *ngIf="attemptClick && campForm.get('studioLocationName')?.invalid" class="invalid-feedback">
                    {{ 'STUDIO_LOCATION_NAME_REQUIRED' | translate }}
                </div>
            </div>
            </div>

            <div class="form-row form-row--full-width">
                <div>
                <label>{{ 'CAMPAIGN_NAME' | translate }} <span class="notification">({{ 'CAMPAIGN_NAME_AUTO_GENERATED' | translate }})</span></label>
                <input readonly
                    [ngClass]="{ 'is-invalid': attemptClick && (!campForm.get('studioLocationName')?.value || !campForm.get('brandName')?.value) }"
                    type="text" 
                    formControlName="campaignName" 
                    class="form-control disabled" 
                />
                </div>
            </div>
        </section>

        <section class="cart-wizard-section-card">
            <div class="cart-wizard-section-card__header">
                <h2 class="cart-wizard-section-card__title">{{ 'LOCATION_DETAILS' | translate }}</h2>
            </div>

            <div class="form-row">
            <div class="dropdown">
                <label>{{ 'STUDIO_STATUS' | translate }}</label>
                <ng-select class="studio-status-select"
                    formControlName="studioStatus">
                    <ng-option *ngFor="let studioStatus of CAMPAIGN_STUDIO_STATUS" [value]="studioStatus.value">{{ studioStatus.value | P_CampaignStudioStatus }}
                    </ng-option>
                </ng-select>
            </div>

            <div>
                <label>{{ 'STUDIO_EMAIL_ADDRESS' | translate }}*</label>
                <input 
                    [ngClass]="{'is-invalid': attemptClick && campForm.get('studioEmail')?.invalid}" 
                    type="email" 
                    formControlName="studioEmail" 
                    class="form-control" 
                />
                <div *ngIf="attemptClick && campForm.get('studioEmail')?.invalid" class="invalid-feedback">
                    {{ 'VALID_EMAIL_IS_REQUIRED' | translate }}
                </div>
            </div>

            <div>
                <label>{{ 'STUDIO_PHONE_NUMBER' | translate }}*</label>
                <input
                    [ngClass]="{ 'is-invalid': attemptClick && campForm.get('studioPhone')?.invalid }"
                    type="text"
                    formControlName="studioPhone" 
                    class="form-control" 
                />
                <div *ngIf="attemptClick && campForm.get('studioPhone')?.invalid" class="invalid-feedback">
                    <span *ngIf="campForm.get('studioPhone')?.errors?.required">{{ 'STUDIO_PHONE_NUMBER_REQUIRED' | translate }}</span>
                    <span *ngIf="campForm.get('studioPhone')?.errors?.maxlength">{{ 'PHONE_MAX' | translate }}</span>
                </div>
            </div>
            </div>

            <div class="form-row form-row--address">
            <div>
                <label>{{ 'STUDIO_STREET' | translate }}*</label>
                <input 
                    [ngClass]="{ 'is-invalid': attemptClick && campForm.get('studioStreet')?.invalid }"
                    type="text" 
                    formControlName="studioStreet" 
                    class="form-control" 
                />
                <div *ngIf="attemptClick && campForm.get('studioStreet')?.invalid" class="invalid-feedback">
                    {{ 'STREET_IS_REQUIRED' | translate }}
                </div>
            </div>

            <div>
                <label>{{ 'STUDIO_CITY' | translate }}*</label>
                <input
                    type="text" 
                    formControlName="studioCity" 
                    class="form-control" 
                />
                <div *ngIf="attemptClick && campForm.get('studioCity')?.invalid" class="invalid-feedback">
                    {{ 'CITY_IS_REQUIRED' | translate }}
                </div>
            </div>

            <div>
                <label>{{ 'STUDIO_STATE' | translate }}*</label>
                <input
                    type="text" 
                    formControlName="studioState" 
                    class="form-control" 
                />
                <div *ngIf="attemptClick && campForm.get('studioState')?.invalid" class="invalid-feedback">
                    {{ 'STATE_IS_REQUIRED' | translate }}
                </div>
            </div>

            <div>
                <label>{{ 'STUDIO_ZIPCODE' | translate }}*</label>
                <input
                    type="text" 
                    formControlName="studioZipcode" 
                    class="form-control" 
                />
                <div *ngIf="attemptClick && campForm.get('studioZipcode')?.invalid" class="invalid-feedback">
                    {{ 'ZIPCODE_IS_REQUIRED' | translate }}
                </div>
            </div>
            </div>

            <div *ngIf="addingFacebook" class="form-row form-row--full-width">
                <div>
                <label>{{ 'FACEBOOK_PAGE_URL' | translate }} <span class="notification">({{ 'IF_RUNNING_FACEBOOK_META_ADS' | translate }})</span></label>
                <input 
                    type="text" 
                    formControlName="fbPageUrl" 
                    class="form-control" 
                />
                </div>
            </div>
        </section>

        <section class="cart-wizard-section-card">
            <div class="cart-wizard-section-card__header">
                <h2 class="cart-wizard-section-card__title">{{ 'ADDITIONAL_DETAILS' | translate }}</h2>
                <p class="cart-wizard-section-card__copy">{{ 'CAMPAIGN_ADDITIONAL_DETAILS_TIP' | translate }}</p>
            </div>

            <div class="form-row">
                <div>
                <label>{{ 'CRM_NAME' | translate }} <span class="notification">({{ 'CRM_NAME_HINT' | translate }})</span></label>
                <div>
                    <ng-select *ngIf="!isCustomCrmName" formControlName="crmName" (change)="onCrmNameChange($event)">
                        <ng-option *ngFor="let c of defaultCRMNames" [value]="c.value">{{c.title}}
                        </ng-option>
                    </ng-select>
                    <div *ngIf="isCustomCrmName" class="crm-name-shell">
                        <input type="text" formControlName="crmName"
                            [ngClass]="{ 'is-invalid': attemptClick && campForm.get('crmName')?.invalid }"
                            [placeholder]="'CRM_NAME' | translate"
                            class="form-control crm-name-input" />
                        <i-feather name="corner-right-up" 
                            (click)="isCustomCrmName = false" [title]="'SHOW_DROPDOWN' | translate"
                            class="icon-sm icon crm-name-toggle"></i-feather>
                    </div>
                </div>
            </div>

            <div>
                <label>{{ 'CRM_ID' | translate }}</label>
                <input 
                    type="text" 
                    formControlName="crmId" 
                    class="form-control"
                />
            </div>
            </div>

            <div class="form-row form-row--full-width">
                <div>
                <label>{{ 'NOTES' | translate }}</label>
                <textarea 
                    type="text" 
                    rows="3" 
                    class="form-control" 
                    formControlName="notes"
                    [placeholder]="'ENTER_NOTE' | translate">
                </textarea>
                </div>
            </div>
        </section>

        <div class="cart-wizard-actions" fxLayout="row wrap" fxLayoutAlign="end center">
            <button 
                type="submit" 
                class="cart-wizard-action-btn new-campaign-submit" 
                [disabled]="!isRequiredFieldsFilled()"
                [ngClass]="isRequiredFieldsFilled() ? 'orange-button' : 'btn btn-page'">
                    {{ 'SUBMIT' | translate }}
            </button>
        </div>
    </form>
</div>
